<template>
  <div id="channel">
    <core-header/>
    <video-filter/>
    <video-list
        :header-has-more="false"
        header-title="热门视频"
        :first-is-enlarge="false"
        :is-paging="false"
        :hotVideo="true"
    />
    <video-list
        :header-has-more="false"
        header-title="频道列表"
        :first-is-enlarge="true"
        :hotVideo="false"
    />

  </div>
</template>

<script>
export default {
  name: 'Channel',

  components: {
    VideoList: () => import('@/components/video/VideoList'),
    CoreHeader: () => import('@/components/core/Header'),
    VideoFilter: () => import('@/components/video/VideoFilter'),
  },
  methods: {}
}
</script>
